import React, { useEffect, useState, useRef } from 'react'
import { ScrollContainer, AnchorButton, Dialog } from '../../Elements'
import { useMediaQuery } from 'react-responsive'


const imageContainerStyle = {
    width: '100%',
    height: '80vh',
    overflow: 'auto',
    cursor: 'grab'
}

const mobileImageContainerStyle = {
    width: '100%',
    overflow: 'auto',
    cursor: 'grab'
}

const Detail = ({ file, close }) => {

    let name = file.key.split('/')
    name = name.length ? name[name.length - 1] : ''
    const imgUrl = name.match(/.(jpg|jpeg|png|gif)$/i) ? file.url : null
    const pdfUrl = name.match(/.(pdf)$/i) ? file.url : null
    const videoUrl = name.match(/.(mp4|webm|ogg|mov)$/i) ? file.url : null

    return (
        <Dialog
            icon='image'
            title={file.key}
            isOpen={true && (imgUrl || pdfUrl || videoUrl) != null}
            canOutsideClickClose={true}
            canEscapeKeyClose={true}
            isCloseButtonShown={true}
            onClose={() => close()}
            style={{ width: '90%', height: '90vh' }}
        >
            <ZoomableImage fileKey={file.key} fileUrl={file.url} />
        </Dialog>
    )
}

export const ZoomableImage = ({ fileKey, fileUrl, shouldResetSize = false }) => {
    const containerRef = useRef(null)
    const isMobile = useMediaQuery({ query: '(max-width: 800px)' })

    let defaultZoom = 0//isMobile ? (w * .80) : w * .80
    const [currentImageWidth, setCurrentImageWidth] = useState(defaultZoom)

    useEffect(() => {
        if (shouldResetSize) setCurrentImageWidth(defaultZoom)
    }, [setCurrentImageWidth, shouldResetSize, defaultZoom])

    let name = fileKey.split('/')
    name = name.length ? name[name.length - 1] : ''

    const imgUrl = name.match(/.(jpg|jpeg|png|gif)$/i) ? fileUrl : null
    const pdfUrl = name.match(/.(pdf)$/i) ? fileUrl : null
    const videoUrl = name.match(/.(mp4|webm|ogg|mov)$/i) ? fileUrl : null

    const zoomin = () => {
        if (currentImageWidth === 2500)
            return

        setCurrentImageWidth(currentImageWidth + 100)
    }

    const zoomout = () => {
        if (currentImageWidth === 100)
            return

        setCurrentImageWidth(Math.max(90, currentImageWidth - 100))
    }

    const onImgLoad = ({target}) => {
        let containerHeight = containerRef.current.offsetHeight
        let containerWidth = containerRef.current.offsetWidth

        let imgHeight = target.offsetHeight
        let imgWidth = target.offsetWidth

        let widthGtContainer = target.offsetWidth > containerWidth
        let heightGtContainer = target.offsetHeight > containerHeight


        let ratio = imgWidth / imgHeight

        let h, w
        let widthNeedsMoreGrowth = containerWidth - imgWidth > containerHeight - imgHeight
        let widthNeedsMoreShrink = imgWidth - containerWidth > imgHeight - containerHeight

        if (widthGtContainer && heightGtContainer) {
            // shrink both until both fit
            if (widthNeedsMoreShrink) {
                w = containerWidth
                h = w/ratio
            } else {
                h = containerHeight
                w = ratio * h
            }
        }

        if (!widthGtContainer && !heightGtContainer) {
            // grow until one fits

            if (widthNeedsMoreGrowth) {
                w = containerWidth
                h = w/ratio
            } else {
                h = containerHeight
                w = ratio * h
            }
        }

        if (widthGtContainer && !heightGtContainer) {
            // shrink width to container
            w = containerWidth
            h = w/ratio
        }

        if (!widthGtContainer && heightGtContainer) {
            // shrink height to container
            h = containerHeight
            w = ratio * h 
        }

        setCurrentImageWidth(w)
    }

    return <>
        <div style={{ border: '1px solid rgb(13,34,74)', height: '100%' }}>
            {imgUrl && <div>
                <div id='button-bar' style={{ backgroundColor: 'rgb(13, 34, 74)', width: '100%', overflow: 'auto' }}>
                    <AnchorButton
                        text={!isMobile && 'Zoom in'}
                        icon='zoom-in'
                        intent='primary'
                        onClick={zoomin}
                        style={{ float: 'left' }}
                    />

                    <AnchorButton
                        text={!isMobile && 'Zoom out'}
                        icon='zoom-out'
                        intent='primary'
                        onClick={zoomout}
                        style={{ float: 'left' }}
                    />

                </div>
                <ScrollContainer
                    innerRef={containerRef}
                    className="scroll-container"
                    style={isMobile? mobileImageContainerStyle : imageContainerStyle}
                    hideScrollbars={false}
                >
                    {imgUrl &&
                        <img id={`zoomableImage${fileUrl}`} src={imgUrl} height='auto' width={currentImageWidth === 0 ? 'auto' : `${currentImageWidth}px`} onLoad={onImgLoad}
                             style={{display: 'block'}} alt={name}/>}
                </ScrollContainer>
            </div>}
            {pdfUrl && !isMobile && <div style={{flexGrow: 1, height: '100%'}}>
                <iframe title='pdf' src={pdfUrl} width='100%' height='100%'/>
            </div>}
            {pdfUrl && isMobile && <a href={pdfUrl} target='_blank' rel='noopener noreferrer' className='bp3-button' style={{margin: '20px'}}> Click to download</a>}
            {videoUrl &&
                <div
                    style={{
                        flexGrow: 1,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%'
                    }}
                >
                    <video
                        controls
                        src={videoUrl}
                        style={{
                            height: '85vmin',
                            width: '-webkit-fill-available'
                        }}
                    >
                        This video could not be displayed.
                    </video>
                </div>}
        </div>
    </>
}

export default Detail